import { render, staticRenderFns } from "./XueTangAdd.vue?vue&type=template&id=921e0d62&scoped=true&"
import script from "./XueTangAdd.vue?vue&type=script&lang=js&"
export * from "./XueTangAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921e0d62",
  null
  
)

export default component.exports